import React, { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom';
import Lottie from 'lottie-react';
import Check from '../assets/check.json';
import Button from './/Button'
import { useNavigate } from 'react-router-dom';

const PaymentSuccessfulPage = () => {
    const [searchParams] = useSearchParams();
    const paymentIntent = searchParams.get("payment_intent")
    const [username, setUsername] = useState('')
    const [cartItems, setCartItems] = useState([])

    const navigate = useNavigate();

    useEffect(() => {
        if (paymentIntent) {
            fetch(`${process.env.REACT_APP_API_URL}/stripe-get-intent?intent=${paymentIntent}`, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            })
                .then((res) => res.json())
                .then((intentData) => {
                    fetch(`${process.env.REACT_APP_API_URL}/get-products`, {
                        method: "GET",
                        headers: { "Content-Type": "application/json" },
                    })
                        .then((res) => res.json())
                        .then((itemData) => {
                            const combinedCartItems = intentData.cartItems.map((cartItem) => {
                                const shopItem = itemData.find((item) => item.sku === cartItem.sku)
                                console.log(shopItem)
                                return {
                                    quantity: cartItem.quantity,
                                    unitAmount: cartItem.unit_amount,
                                    item_name: cartItem.name,
                                    item_image: shopItem.item_image,
                                    discount_price: shopItem.discount_price,
                                    item_price: shopItem.item_price,
                                }
                            })
                            setUsername(intentData.username)
                            setCartItems(combinedCartItems)
                            console.log(combinedCartItems)
                        });
                });
        }
    }, [paymentIntent])

    return (
        <div className="centered">
            <div className="container narrow-container">
                <div className="username-section">
                    <div className="username-box">
                        <label>Dear {username},</label>
                        <hr />
                        <div className="form-fields">
                            <h1 style={{ fontSize: '24px' }}>Thank you for your purchase!</h1>
                            <div className="lottie-container" style={{ width: '150px', textAlign: 'center', margin: 'auto', }}>
                                <Lottie loop={true} animationData={Check} />
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                {
                                    cartItems.map(product => {
                                        return (
                                            <div className="product-card">
                                                <img src={product.item_image} alt={product.item_name} />
                                                <h3>{product.item_name}</h3>
                                                <p style={{ fontSize: '18px', marginTop: '15px' }}>{product.discount_price > 0 ? (<><s style={{ color: '#b70909' }}>${product.item_price}</s> <span style={{ color: '#66f166', textShadow: '0px 0px 10px #66f166' }}>${product.discount_price}</span></>) : (<div style={{ textShadow: '0px 0px 10px gold' }}>${product.item_price}</div>)}</p>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <Button style={{ marginTop: '25px' }} onClick={() => navigate('/')} >Go back</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default PaymentSuccessfulPage
